import React from "react";
import { StyledButtons } from "./styled";
import MapButton from "../MapButton";
import { initialBounds } from "../../config";

function MapButtons({
  className,
  mapRef,
  onReset,
  showStates = false,
  showReset = false,
  showLegend = false,
  legendOpen = false,
  onToggleLegend,
  ...props
}) {
  const handleUSAClick = () => {
    mapRef.current.fitBounds(initialBounds, { zoom: 3 });
  };

  const handleHawaiiClick = () => {
    mapRef.current.fitBounds([
      [-161.4111328125, 17.156537255486093],
      [-152.3583984375, 23.498514375479786],
    ]);
  };

  const handleAlaskaClick = () => {
    mapRef.current.fitBounds([
      [-173.056640625, 50.31039245071915],
      [-128.583984375, 72.24556692540702],
    ]);
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <StyledButtons className={className}>
      {showLegend && (
        <MapButton
          label="Toggle legend"
          aria-expanded={legendOpen}
          aria-controls="map-legend"
          isActive={legendOpen}
          onClick={onToggleLegend}
        >
          <img src="/key.svg" alt="" />
        </MapButton>
      )}
      {showStates && (
        <>
          <MapButton label="Hawaii" onClick={handleHawaiiClick}>
            <svg width="20.206" height="16.083" viewBox="0 0 20.206 16.083">
              <path
                d="M15.775,9.588v.754l.252.387-.087.368-.438.443-.269.608.093.45.318.69.138.543-.092,1.016.112.526.363.387.5.323h.15l.237-.529.475-.72.624-.346.807-.136.646-.347.6-.6-.054-.23-.254-.1-.435-.642-.351-.337-.123-.613-.524-.492-.726-.517-.918-.4L16.172,9.6l-.259-.137ZM11.129,6.38,11.07,6.6l.19.328.071.31.425.073.174-.053.049-.3-.042-.33-.23-.189-.193-.118ZM12.6,5.951l-.111.281.073.439.34.26.434.085.155.293.086.589,0,.162.162.136.406-.058.336-.249.285-.118.479-.087.235-.259.081-.27-.359-.4-.391-.112-.371-.318-.484-.062-.35.157-.2-.064-.208-.3-.334-.2Zm-2.289-.968-.086.076-.144.244.062.358.541.058.164-.177.212.077.437.073.608-.065.223-.254L12.241,5.2l-.686-.065L10.9,4.918ZM7.278,2.5l-.251.143L6.9,2.859l-.163.165-.281.114-.135.224.077.371.382.644.192.186.142-.07.133-.2.309-.048.126.254.207.253.254.065.36-.059.126-.271-.259-.545-.336-.129-.209-.225-.181-.52-.13-.475-.112-.1ZM1.591,0,.763.121.333.342.091.657,0,1.106l.261.318.483.128.489.23.088.124.19-.056.334-.435.1-.4V.4l-.2-.362Z"
                fill="#002B43"
              />
            </svg>
          </MapButton>
          <MapButton label="Alaska" onClick={handleAlaskaClick}>
            <svg width="20.837" height="18.112" viewBox="0 0 20.837 18.112">
              <path
                d="M7.577,14.863l-.547.285.011.485.242.3.6-.306.537-.418-.189-.345-.349-.117ZM1,10.861l.221.362.275.283.353-.068.061-.4-.369-.2ZM0,6.971.077,7.1.5,7.18l.112.243.277.338.42-.1.074-.1L.97,7.276.693,6.883l-.319.007L.164,6.6ZM8.647,0l-.7.516L7.61.368,6.773.724,6.366.768l-.529.444L5.6,1.738l-.636.378L4.25,1.955l-.393.511.46.507.269.575.155.623.42.546.191.755-.931-.187.2-.522L4.264,4.67l-1.106.252-.743.258.369.78.063.477.589.438.672.052.3.323.2-.2.536-.116.282.052-.432.332L5.2,7.57l-.023.5-.431.245-.318-.172-.5.41-.28-.249-.4-.024-.311.485-.548.464-.354.532.253.538-.157.573.275.336.3.585.708-.026.241.439-.182.348-.1.609.32.076.612-.285.086.545.219-.331.236.584.36-.31.135.208.665-.192-.38.549-.237.746-.468.276-.161.175-.882.437-.361.346-.712-.046-.722.392-.623.161-.734.289.044.187,1.04-.023.549-.21.647-.2.583-.157.367.159.74-.29.266-.432.953-.356.213-.421.594-.216.646-.332.61-.659-.313-.552.853-.626.439-.645.714-.506.111.278-.577.26-.355.988v.616l.609-.151.5-.3.624-.159.293-.042-.047-.732.585-.177.581.485,1,.528.724-.068.91.382.5.2,1.123,1.051.644.272.862-.02.525.032.367.941.786.758.242.863.535.269.357.342.264-.518-.09-.63-1.022-.538-.672-1.105-.4-.7-.526-.427-.386-.4-.311-.519-.511.363-.493.6-.491-.665-.375-.448-.511-.282-.51-.03.028-6.113.02-4.213-.437-.167-.6-.367-.54.169-.3-.168-.758-.162-.8-.444-.413.075-.575-.272.058-.267L9.583.717l-.206.2-.2-.573Z"
                fill="#002B43"
              />
            </svg>
          </MapButton>
          <MapButton label="USA" onClick={handleUSAClick}>
            <svg width="22.738" height="15" viewBox="0 0 22.738 15">
              <defs>
                <clipPath>
                  <rect width="22.738" height="15" fill="#002B43" />
                </clipPath>
              </defs>
              <g clip-path="url(#clip-path)">
                <path
                  d="M22.629,1.4a.638.638,0,0,0-.979-.45,1.546,1.546,0,0,0-.44.275c-.266.256-.5.542-.763.805a1.152,1.152,0,0,1-.4.315,2.743,2.743,0,0,0-1.29.995,10.636,10.636,0,0,1-.837.916c-.181.18-.365.1-.433-.143a2.929,2.929,0,0,0-.172-.534.672.672,0,0,0-.855-.374,2.759,2.759,0,0,0-.553.248c-.227.127-.44.276-.718.453.031-.232.046-.4.079-.574a.763.763,0,0,0-.383-.943,2.079,2.079,0,0,0-.6-.3c-.716-.178-1.436-.351-2.163-.475-.65-.11-1.314-.137-1.968-.229-.408-.058-.8-.19-1.212-.253C8.409,1.046,7.874,1,7.341.938,6.678.865,6.013.806,5.35.73,4.732.658,4.109.6,3.5.482,2.913.368,2.341.175,1.761.031a.538.538,0,0,0-.737.433C.95.727.9,1,.846,1.266A9.85,9.85,0,0,1,.252,3.5a2.767,2.767,0,0,0-.227.962,17.569,17.569,0,0,0,0,1.765A4.094,4.094,0,0,0,.629,8.311a6.371,6.371,0,0,0,2.153,2.061A27.08,27.08,0,0,0,7.87,12.718,3.878,3.878,0,0,1,9.7,13.995a9.436,9.436,0,0,0,.661.753.7.7,0,0,0,.774.21,1.091,1.091,0,0,0,.844-1.2c0-.029,0-.058,0-.087.012-.29.074-.354.361-.38a12.1,12.1,0,0,0,1.278-.126,17.42,17.42,0,0,0,1.7-.444,1.437,1.437,0,0,1,1.773.622,7.326,7.326,0,0,0,.854,1.042.849.849,0,0,0,1.382-.138,2.128,2.128,0,0,0,.184-1.945,3.777,3.777,0,0,1-.243-1.137,1.335,1.335,0,0,1,.268-.9c.173-.242.352-.481.507-.735A2.554,2.554,0,0,0,20.436,8,2.755,2.755,0,0,1,21.495,5.4a1.37,1.37,0,0,0,.581-1.041,1.486,1.486,0,0,1,.235-.732A2.57,2.57,0,0,0,22.629,1.4"
                  transform="translate(0 -0.001)"
                  fill="#002B43"
                />
              </g>
            </svg>
          </MapButton>
        </>
      )}
      {showReset && (
        <MapButton label="Reset" onClick={handleReset}>
          <img src="/center.svg" alt="" />
        </MapButton>
      )}
    </StyledButtons>
  );
}

export default MapButtons;
